<!--  -->
<template>
  <div>
    <div style="margin-bottom: 20px;display:flex;flex-wrap:wrap" class="search_box">
      <el-input v-model="query.keyword" placeholder="请输入小程序名称/appid/编号" style="width:230px" />
      <el-input v-model="query.title" placeholder="请输入小程序标题" style="width:218px;" />
      <el-select v-model="query.onlyMe" placeholder="请选择">
        <el-option
          v-for="item in accountarr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input v-model="query.remark" placeholder="请输入备注" style="width:218px;" />
      <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
    </div>
    <div class="chooser_allbox">
      <div v-for="item,index in tableData" :key="index" class="chooser_box">
        <div class="chooser_allbox">
          <img v-if="item.weappiconurl!=''" :src="item.weappiconurl" alt="" srcset="" style="width:30px;border-radius: 50%;">
          <img v-else src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" style="width:30px;border-radius: 50%;">
          <!-- <div class="titlew_box">{{ item.title }}</div> -->
          <div class="titlew_box">{{ item.des_1 }}</div>
        </div>
        <div class="daser">{{ item.title }}</div>
        <div class="cahrw_box">
          <img :src="item.thumburl" alt="" srcset="" style="width:100%;height: 158px;">
        </div>
        <div class="line" />
        <div style="color:#252525;margin-top: 5px;">
          <span style="font-size: 15px;display: flex;align-items: center;flex-wrap: wrap;margin-bottom: 10px;">
            <el-avatar :size="20" :src="item.sender_avatar" @error="errorHandler">
              <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
            </el-avatar><el-tag v-if="item.sender!=''" style="margin-left: 10px;"> {{ item.sender }}</el-tag>
            <!-- <div v-else style="margin-left: 10px;width: 70px;height: 27px;" /> -->
            <div style="margin-left:10px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size:14px">{{ item.remark }}</div>
          </span>
          <div style="margin-bottom: 10px;">
            <el-tag type="warning">{{ item.type_text }}</el-tag>
          </div>
          <div style="display: flex;">
            <el-tag> {{ item.created_at_str }}</el-tag>
            <el-button type="primary" size="mini" style="margin-left: 10px;" @click="choose(item)">选择</el-button>
          </div>
          <div style="font-size: 12px;margin-top: 10px;" class="copy_box">
            <el-tag v-if="item.miniprogram_no!=''" type="success">{{ item.miniprogram_no }}</el-tag>
            <div v-if="item.miniprogram_no!=''" class="copy_icon"><i
              v-clipboard:copy="item.miniprogram_no"
              v-clipboard:success="cowe"
              v-clipboard:error="onError"
              style="cursor: pointer;margin-left: 2px;"
              class="el-icon-document-copy"
            /></div>
          </div>
        </div>
      </div>

    </div>
    <pagination-right
      :current-page="query.page"
      :page-sizes="[10]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { miniprogramList } from '@/api/messageTemplate.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [], // 官方小程序列表
      total: null,
      query: {
        page: 1,
        page_size: 10,
        type: 3,
        onlyMe: 2,
        keyword: null,
        title: null,
        remark: null
      },
      accountarr: [{
        value: 1,
        label: '查看组内小程序'
      }, {
        value: 2,
        label: '我关联的小程序'
      }]

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.list()
    },
    // 官方小程序列表
    async list() {
      const data = await miniprogramList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('miniprogramList data', this.tableData)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    errorHandler() {},
    choose(item) {
      this.$emit('chooseminofficialcallback', item)
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keyword = null
      this.query.title = null
      this.query.onlyMe = 2
      this.query.remark = null
      this.list()
    },
    cowe() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError() {
      this.$message({
        message: '复制失败',
        type: 'error'
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.chooser_allbox{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 600px;
  overflow-y: auto;
}
.chooser_box{
  width: 250px;
  height: 430px;
  border: 1px solid #e9e9e9;
  padding: 12px;
  box-sizing: border-box;
  /* margin: 0 auto; */
  margin-bottom: 20px;
  margin-right: 30px;
}
.titlew_box{
  margin-left: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cahrw_box{
  margin-top: 10px;
}
.line{
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.daser{
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 227px;
  margin-top:5px;
  height: 37px;
}
.copy_box{
  display: flex;
  align-items: center;
}
.copy_icon{
  margin-left: 5px;
}
.chooser_allbox{
  width:100%;
  gap:10px;
  padding:0px;
}
.chooser_allbox .chooser_box{
  margin:0px;
  width:245px;
}
@media (max-width: 768px){
  .chooser_allbox{
    justify-content:center;
  }
  .chooser_allbox .chooser_box{
    width:60vw;
  }
}
</style>
